import React, { useState, useEffect } from 'react';

const MOCK_SEQUENCE = [
  {
    state: 'idle',
    badge: 'READY',
    headline: 'Tap To Open Bidding',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Current Bid', bidValue: 'Opening Bid Needed', bidIsText: true,
    showReset: false,
    timerValue: null, timerCaption: 'Timer starts after the opening bid.',
    fill: 0, dur: 2000,
  },
  {
    state: 'waiting',
    badge: 'BIDDING OPEN',
    headline: 'Waiting For Opening Bid',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Current Bid', bidValue: 'Opening Bid Needed', bidIsText: true,
    showReset: false,
    timerValue: null, timerCaption: 'No countdown yet.',
    fill: 0, dur: 2000,
  },
  {
    state: 'active',
    badge: 'BID HEARD',
    headline: 'Bid Accepted',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Current Bid', bidValue: '$38', bidIsText: false,
    showReset: true,
    timerValue: '4.8s remaining', timerCaption: 'Waiting for next higher bid.',
    fill: 0.95, dur: 1800,
  },
  {
    state: 'active',
    badge: 'BIDDING OPEN',
    headline: 'Listening For Bids',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Current Bid', bidValue: '$50', bidIsText: false,
    showReset: true,
    timerValue: '2.9s remaining', timerCaption: 'Waiting for next higher bid.',
    fill: 0.58, dur: 2200,
  },
  {
    state: 'going-once',
    badge: 'FINAL CALL',
    headline: 'Going Once',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Current Bid', bidValue: '$51', bidIsText: false,
    showReset: true,
    timerValue: '2.5s remaining', timerCaption: 'Closing interval in progress.',
    fill: 0.50, dur: 1800,
  },
  {
    state: 'going-twice',
    badge: 'FINAL CALL',
    headline: 'Going Twice',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Current Bid', bidValue: '$51', bidIsText: false,
    showReset: true,
    timerValue: '1.2s remaining', timerCaption: 'Closing interval in progress.',
    fill: 0.24, dur: 1800,
  },
  {
    state: 'sold',
    badge: 'SOLD',
    headline: '',
    name: 'Justin Jefferson', pos: 'WR', team: 'MIN',
    bidLabel: 'Sold At', bidValue: '$51', bidIsText: false,
    showReset: false,
    timerValue: null, timerCaption: null,
    fill: 0, dur: 2200,
  },
];

function MockAuctionBoard() {
  const [step, setStep] = useState(0);
  const [fill, setFill] = useState(MOCK_SEQUENCE[0].fill);
  const cur = MOCK_SEQUENCE[step];

  useEffect(() => {
    setFill(cur.fill);
    const timers = [];

    timers.push(setTimeout(() => setStep((s) => (s + 1) % MOCK_SEQUENCE.length), cur.dur));

    if (cur.state === 'active') {
      timers.push(setTimeout(() => setFill(Math.max(0.08, cur.fill - 0.5)), 80));
    }
    if (cur.state === 'going-once' || cur.state === 'going-twice') {
      timers.push(setTimeout(() => setFill(0.04), 80));
    }

    return () => timers.forEach(clearTimeout);
  }, [step, cur.fill, cur.dur, cur.state]);

  const stateTone = cur.state === 'idle' || cur.state === 'waiting'
    ? 'waiting'
    : cur.state === 'going-once' || cur.state === 'going-twice'
      ? 'final-call'
      : cur.state;

  return (
    <div className="fa-mock-board" data-state={stateTone} aria-live="polite">
      <div className="fa-mock-board__status-bar">
        <span className={`fa-mock-board__badge fa-mock-board__badge--${stateTone}`}>
          {cur.badge}
        </span>
        <h3 className="fa-mock-board__headline" style={{ visibility: cur.headline ? 'visible' : 'hidden' }}>
          {cur.headline || ' '}
        </h3>
      </div>

      <div className="fa-mock-board__panels">
        <div className="fa-mock-board__stage-panel">
          <div className="fa-mock-board__player-name">{cur.name}</div>
          <div className="fa-mock-board__player-meta">{cur.pos} &middot; {cur.team}</div>
        </div>

        <div className="fa-mock-board__live-panel">
          <div className="fa-mock-board__bid-block">
            <div className="fa-mock-board__bid-label">{cur.bidLabel}</div>
            <div className="fa-mock-board__bid-row">
              <div className="fa-mock-board__bid-value-wrapper">
                <div className="fa-mock-board__bid-value fa-mock-board__bid-value--sizer" aria-hidden="true">$00</div>
                <div className={`fa-mock-board__bid-value${cur.bidIsText ? ' fa-mock-board__bid-value--text' : ''}`}>
                  {cur.bidValue}
                </div>
              </div>
              <div className="fa-mock-board__reset-button" style={{ visibility: cur.showReset ? 'visible' : 'hidden' }}>
                Reset Bid
              </div>
            </div>
          </div>

          <div className="fa-mock-board__timer-block">
            <div className="fa-mock-board__timer-value" style={{ visibility: cur.timerValue ? 'visible' : 'hidden' }}>
              {cur.timerValue || ' '}
            </div>
            <div className="fa-mock-board__timer-track">
              <div className="fa-mock-board__timer-fill" style={{ '--fill': fill }}></div>
            </div>
            <div className="fa-mock-board__timer-caption" style={{ visibility: cur.timerCaption ? 'visible' : 'hidden' }}>
              {cur.timerCaption || ' '}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MockAuctionBoard;
